export default {
  methods: {
    closePageForm () {
      this.$Message.info({
        content: '页面将 2 秒后自动关闭',
        duration: 2,
        onClose: () => {
          window.close()
        }
      })
    },
    jumpStoreChang () {
      // this.$store.commit('Toutiao/setCurrent', 'idea')
      // this.$store.commit('Toutiao/changeState', 'plan')
    }
  }
}
